import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import { errorAction } from '../extensions';
import { log, normalizeErrors } from '../../handlers/error';
import { NormalizedError } from '../../types';

export class LogErrorsPlugin implements PluginInterface {
  init(context: CastReceiverContext) {
    errorAction.register(e => {
      const normalizedErrors = normalizeErrors(e);
      for (const error of normalizedErrors) {
        if (hasErrorDetails(error)) {
          log(error);
        }
      }
    });
  }
}

function hasErrorDetails(error: NormalizedError & { isErrorTypeFatal: boolean }) {
  return (
    (error.stack !== undefined && error.stack !== '') ||
    error.raw !== undefined ||
    error.message !== undefined
  );
}
